import React, { createContext, useContext, useState, ReactNode } from 'react'
import { CToast, CToastBody, CToastClose, CToaster } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCheckCircle, cilWarning, cilInfo, cilXCircle } from '@coreui/icons'

interface ToastContextType {
  showToast: (message: string, type?: 'success' | 'error' | 'info' | 'warning') => void
}

const ToastContext = createContext<ToastContextType | undefined>(undefined)

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toasts, setToasts] = useState<any[]>([])

  const showToast = (message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info') => {
    const id = Date.now()
    const newToast = {
      id,
      message,
      type,
    }
    setToasts((prev) => [...prev, newToast])

    // Auto-remove after 5 seconds
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id))
    }, 5000)
  }

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <CToaster placement="top-end" className="ql-toaster">
        {toasts.map((toast) => (
          <CToast
            key={toast.id}
            visible
            autohide={true}
            className={`ql-toast ql-toast--${toast.type}`}
          >
            <CToastBody>
              <div className="ql-toast__content">
                <div className="ql-toast__icon-wrapper">
                  <CIcon
                    icon={
                      toast.type === 'success'
                        ? cilCheckCircle
                        : toast.type === 'warning'
                        ? cilWarning
                        : toast.type === 'error'
                        ? cilXCircle
                        : cilInfo
                    }
                    className="ql-toast__icon"
                  />
                </div>
                <div className="ql-toast__text">
                  <div className="ql-toast__title">
                    {toast.type === 'success'
                      ? 'Success'
                      : toast.type === 'warning'
                      ? 'Warning'
                      : toast.type === 'error'
                      ? 'Error'
                      : 'Info'}
                  </div>
                  <div className="ql-toast__message">{toast.message}</div>
                </div>
                <CToastClose className="ql-toast__close" />
              </div>
            </CToastBody>
          </CToast>
        ))}
      </CToaster>
    </ToastContext.Provider>
  )
}

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}


